<section class="container mb-4">
    <div class="row mb-4 mt-4">
        <!-- Mobile only Order Total -->
    <section class="col-md-12 py-4 u-border-top-grey d-flex align-items-center justify-content-center justify-content-md-between flex-column flex-md-row d-block d-sm-none">
            <ng-container *ngIf="!stdCartType">
        <h3 class="font-bold mb-0">{{ totalInfluenzaProducts }}</h3>
        <h1 class="font-bold mb-0">{{ totalInfluenzaDoses }} {{ 'plp.doses' | cxTranslate }}</h1>
            </ng-container>
            <ng-container *ngIf="stdCartType; else fluCartOrderTotal">
        <div class="d-flex flex-column w-100">
          <div class="d-flex w-100 align-items-center justify-content-between">
            <h3 class="font-bold mb-0">{{ 'addToCartItems.orderTotal' | cxTranslate }}:</h3>
            <h1 class="font-bold mb-0">{{ standardCartDetails?.totalPriceWithTax?.value | currency }}</h1>
          </div>
          <hr class="my-3 w-100"/>
          @if (standardCartDetails?.promptPayDiscountTotal) {
            <div class="d-flex w-100 align-items-center justify-content-between">
              <span>{{ 'addToCartItems.promptPayDiscountTotal' | cxTranslate }}:</span>
              <span>{{ (standardCartDetails?.totalPriceWithTax?.value - standardCartDetails?.promptPayDiscountTotal) | currency }}</span>
            </div>
          }
        </div>
            </ng-container>
      <ng-template #fluCartOrderTotal>
        <span class="est-Header">
          <h3 class="font-bold mb-0">{{ 'addToCartItems.estTotal' | cxTranslate }}:</h3>
          <h1 class="font-bold mb-0">{{ standardCartDetails?.totalPriceWithTax?.value | currency }}</h1>
        </span>
      </ng-template>
        </section>
        <!-- Buttons tablet and desktop -->
    <section class="col-md-12 d-flex justify-content-around justify-content-md-end mb-4 d-block d-sm-none">
      <button class="c-button c-button--secondary mr-md-3" (click)="navigateToCart()">
        {{ 'addToCartItems.editCart' | cxTranslate }}
      </button>
      <button
        class="c-button c-button--primary"
        (click)="checkout()"
        [disabled]="((orderNo == undefined || orderNo == '') && !genMedFlag) || disablePlaceOrderBtn"
      >
        {{ 'addToCartItems.continue' | cxTranslate }}
      </button>
        </section>
        <!-- Terms and condition -->
        <section class="col-md-12 mb-4 u-border-bottom-grey pb-4 d-block d-sm-none">
            <div *ngIf="stdCartType; else fluCartTerm">
                <app-terms-conditions compName="TandC-checkout"></app-terms-conditions>
            </div>
            <ng-template #fluCartTerm>
        <app-terms-conditions compName="TandC-fluseasonviewpayment"></app-terms-conditions>
            </ng-template>
        </section>
        <!-- Mobile only total end-->

        <!-- Main content -->
        <div class="col-md-8 u-border-right-grey pr-md-4 pr-lg-5">
            <section class="row pb-4 u-border-bottom-grey">
                <div class="col-md-8 mb-2">
                    <ng-template #fluPayment>
                        <section class="checkOut-Header">
                            <span class="checkOut-Header-text">{{'addToCartItems.verifyPayment' | cxTranslate }}</span>
                            <section class="float-right sm-float-left p-left-flu" *ngIf="estimatedDate != ''">
                                <p class="fw-bold text_indent">
                  {{ 'addToCartItems.deliveryDate' | cxTranslate }}
                                    <span class="light-color fw-normal ml1">{{ estimatedDate | slice : 0 : 10 | date : dateFormat }}</span>
                                </p>
                            </section>
                        </section>
                    </ng-template>
          <div class="firstLevel-acc checkout-heading-acc" *ngIf="stdCartType; else fluPayment">
                        <ng-template #deliveryLoc>
                            <i class="fa fa-map-marker-alt font-n"></i>
              <span class="px-3 text-fixed-medium">
                {{ selectedData?.companyName }}
                {{ '(' + selectedData?.unitID + ')' }}
              </span>
            </ng-template>
            <div *ngIf="standardCartDetails?.pickupDate; else deliveryLoc" class="pickupLocation">
              <h6>{{ 'addToCartItems.pickLocation' | cxTranslate }}</h6>
              <p>
                {{ 'addToCartItems.sanofiName' | cxTranslate }} <br />
                {{'addToCartItems.locationLine1' | cxTranslate
                }}<br />{{ 'addToCartItems.locationLine2' | cxTranslate }}
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- Shipping -->
      <section class="row pt-4 text-fixed-medium mb-3">
        <section class="col-md-7" *ngIf="standardCartDetails?.pickupDate === undefined">
          <h3 class="font-bold">{{ 'addToCartItems.shipTo' | cxTranslate }}</h3>
          <p class="text-fixed-medium">
            {{ selectedData?.companyName ? selectedData?.companyName : ''
            }}<br />
            {{ selectedData?.line1 ? selectedData?.line1 : '' }}
            {{ selectedData?.line2 ? selectedData?.line2 : '' }}<br />
            {{ selectedData?.town ? selectedData?.town : '' }} ,
            {{
              selectedData?.region?.isocodeShort
                ? selectedData?.region?.isocodeShort
                : ''
            }}
            {{ selectedData?.postalCode ? selectedData?.postalCode : '' }}
          </p>
        </section>
        <section class="col-md-5 mb-4 mb-md-0">
          <h3 class="font-bold">PO#</h3>
          <div class="c-text-input">
            <input
              type="text"
              class="focus-visible focus-visible--danger"
              (keyup)="orderNoUpdate()"
              [(ngModel)]="orderNo"
              maxlength="20"
              [ngClass]="{
                invalidClass:
                  (orderNo == undefined || orderNo == '') && !genMedFlag
              }"
            />
          </div>
          <h3 class="font-bold">
            {{ 'addToCartItems.attentionLine' | cxTranslate }}
          </h3>
          <div class="c-text-input">
            <input
              type="text"
              class="focus-visible focus-visible--danger"
              [(ngModel)]="attentionLine"
              maxlength="50"
            />
          </div>
        </section>
      </section>

      <!-- Product items -->
      <ng-container *ngIf="salesOrg && salesOrg.indexOf(SalesOrg.US12) > -1">
        <div class="row brand-banner mb-4" *ngIf="orderMessage">
          <div class="col-md-12 p-2">
            <p class="font-bold m-0 p-2">{{ orderMessage }}</p>
          </div>
        </div>
        <div *ngFor="let productentry of combinedProdEntries" class="pdp-list-data row c-prod-details py-2">
          <ng-container *ngIf="productentry?.product">
            <div class="col-md-12 col-lg-2 mb-4 mb-lg-0">
              <a (click)="productDetails(productentry)">
                <img class="img-fluid" src="{{ productentry.PRIMARY ? productentry?.PRIMARY?.url : fallbackImage}}" alt=""/>
              </a>
            </div>
            <div class="col-md-12 col-lg-10">
              <div class="row">
                <div class="col-md-12">
                  <a (click)="productDetails(productentry)">
                    <h2 class="font-bold c-heading c-heading-h4 mb-4">{{ productentry.product?.name }}</h2>
                  </a>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 mb-4 mb-md-0">
                  <!-- Prod number -->
                  <p class="text-fixed-legal-copy mb-1">
                    <span class="font-bold">{{'plp.productNumber' | cxTranslate }}</span>
                    <br />
                    {{ productentry?.product?.sapEan }}
                  </p>
                  <!-- Potency -->
                  <p class="text-fixed-legal-copy" *ngIf="productentry?.product?.actualPotency">
                    <span class="font-bold">{{'plp.actualPotency' | cxTranslate }}</span>
                    <br />
                    {{ productentry.product?.actualPotency }}
                  </p>
                </div>
                <div class="col-6 col-md-3">
                  <!-- Batch -->
                  <p class="text-fixed-legal-copy mb-1">
                    <span class="font-bold">Batch number</span><br /> {{ productentry.product?.batchInfo?.batchNumber }}
                            </p>
                            <!-- Potency -->
                  <p class="text-fixed-legal-copy mb-1" *ngIf="!productentry.product?.fitusiran && ! productentry.product?.wayrilz">
                    <span class="font-bold">Total Potency</span><br />
                    {{ productentry.product?.actualPotency }}
                            </p>

                            <!-- IU Price -->
                  <p class="text-fixed-legal-copy mb-1" *ngIf="!productentry.product?.fitusiran && ! productentry.product?.wayrilz">
                    <span class="font-bold">IU Price</span><br />
                    {{ productentry.iuPrice?.value | currency }}
                            </p>
                    </div>
                    <div class="col-6 col-md-3">
                        <p class="text-fixed-legal-copy mb-1">
                    <span class="font-bold">Expiration</span><br />
                    {{ productentry.product?.batchInfo.expiryDate | date : 'MM/dd/yyyy' }}
                        </p>
                        <p class="text-fixed-legal-copy mb-1">
                            <span class="font-bold">Unit Price</span><br /> {{ productentry?.basePrice?.value | currency }}
                        </p>
                        <p class="text-fixed-legal-copy mb-1">
                            <span class="font-bold">Subtotal</span><br /> {{ productentry?.totalPrice?.value | currency }}
                        </p>
                    </div>
                    <div class="col-md-3 mt-4 mt-md-0">
                        <p class="text-fixed-legal-copy mb-1">
                    <span class="font-bold">{{ 'plp.units' | cxTranslate }}</span>
                    <br />
                    {{ productentry?.quantity }}
                  </p>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="productentry.multi">
            <div class="pdp-list-data w-100 c-prod-details mt-3"></div>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="salesOrg && salesOrg.indexOf(SalesOrg.US12) == -1">
        <section class="row u-border-top-grey py-4 mt-4 mt-md-0" *ngFor="let productEntry of productEntries">
          <!-- image -->
          <section class="col-md-2 mb-4">
            <a (click)="productDetails(productEntry)">
              <img
                class="prod-Image"
                *ngIf="productEntry?.PRIMARY !== undefined; else undefinedImg"
                src="{{ productEntry?.PRIMARY?.url }}"
                alt="Product Image"
              />
              <ng-template #undefinedImg>
                <img class="prod-Image" [src]="fallbackImage" alt="" />
              </ng-template>
            </a>
          </section>
          <!-- details -->
          <section class="col-md-10">
            <section class="row c-prod-details">
              <div class="col-md-12">
                <a (click)="productDetails(productEntry)">
                  <h2 class="font-bold c-heading c-heading-h4 mb-4" [innerHTML]="productEntry?.product?.name"></h2>
                </a>
              </div>

              <div class="col-md-12 d-md-flex justify-content-between text-fixed-medium">
                <div>
                  <span class="font-bold">{{ 'plp.units' | cxTranslate }}</span>
                            <span class="d-inline-block d-sm-none">:&nbsp;{{ productEntry?.quantity }}</span>
                  <span class="d-none d-md-block">{{ productEntry?.quantity }}</span>
                    </div>
                    <div>
                  <span class="font-bold" *ngIf="productEntry?.product?.actualPotency; else notActualPotency">
                    {{ 'plp.your_price' | cxTranslate }}
                  </span>
                  <ng-template #notActualPotency>
                    <span class="font-bold">{{'plp.yourPrice' | cxTranslate }}</span>
                        </ng-template>
                        <span class="d-inline-block d-sm-none">:&nbsp;{{ productEntry?.basePrice?.value | currency }}</span>
                  <span class="d-none d-md-block">{{ productEntry?.basePrice?.value | currency }}</span>
                    </div>
                    <div>
                        <span class="font-bold">{{'addToCartItems.subtotal' | cxTranslate }}</span>
                        <span class="d-inline-block d-sm-none">:&nbsp;{{ productEntry?.totalPrice?.value | currency }}</span>
                        <span class="d-none d-md-block">{{ productEntry?.totalPrice?.value | currency }}</span>
                    </div>
                </div>
                <section class="col-md-12 text-fixed-medium py-4">
                <div class="m-0" [innerHTML]="productEntry?.product?.description"></div>
                </section>
                <section class="col-md-12 text-fixed-medium">
                    <span class="font-bold">{{ 'plp.productNumber' | cxTranslate }}</span> {{ productEntry?.product?.sapEan }}<br />
                    <div *ngIf="productEntry?.product?.actualPotency">
                        <span class="font-bold">{{ 'plp.actualPotency' | cxTranslate }}:</span>
                  {{ productEntry?.product?.actualPotency }}<br />
                  <span class="font-bold">{{ 'plp.totalPotency' | cxTranslate }}:</span>
                  {{ productEntry?.product?.actualPotency * productEntry?.quantity }}
                </div>
              </section>
            </section>
          </section>
        </section>
      </ng-container>
    </div>

    <!-- Sidebar -->
    <div class="col-md-4 pl-md-4 pl-lg-5">
      <section class="row">
        <!-- Order Total -->
        <section class="col-md-12 py-4 d-flex align-items-center justify-content-center justify-content-md-between flex-column flex-md-row">
          @if (stdCartType) {
            <div class="d-flex flex-column w-100">
              <section>
                <div class="row mb-3">
                  <div class="col-6">{{ 'addToCartItems.subtotal' | cxTranslate }}</div>
                  <div class="col-6 text-right">{{ standardCartDetails?.subTotal?.value | currency }}</div>
                </div>
                @if (standardCartDetails?.totalTax?.value) {
                  <div class="row py-1 mb-2">
                    <div class="col-6">{{ 'addToCartItems.salesTax' | cxTranslate }}</div>
                    <div class="col-6 text-right">{{ standardCartDetails?.totalTax?.value | currency }}</div>
                  </div>
                }
                <hr class="my-3 w-100"/>
                <div class="row py-1 font-bold h4">
                  <div class="col-6">
                    <span class="shipTo-Header total-Amount-Span">{{ 'addToCartItems.orderTotal' | cxTranslate }}</span>
                  </div>
                  <div class="col-6 text-right">{{ standardCartDetails?.totalPriceWithTax?.value | currency }}</div>
                </div>
              </section>
              @if (standardCartDetails?.promptPayDiscountTotal) {
                <p class="mt-4 mb-3">{{ 'addToCartItems.promptPayDiscountDisclaimer' | cxTranslate }}</p>
                <div class="d-flex w-100 align-items-center justify-content-between font-bold h4">
                  <span>{{ 'addToCartItems.promptPayDiscountTotal' | cxTranslate }}:</span>
                  <span>{{ (standardCartDetails?.totalPriceWithTax?.value - standardCartDetails?.promptPayDiscountTotal) | currency }}</span>
                </div>
              }
            </div>
          } @else {
            <h3 class="font-bold mb-0">{{ totalInfluenzaProducts }}</h3>
            <h1 class="font-bold mb-0">{{ totalInfluenzaDoses }} {{ 'plp.doses' | cxTranslate }}</h1>

            <span class="est-Header">
              <h3 class="font-bold mb-0">{{ 'addToCartItems.estTotal' | cxTranslate }}:</h3>
              <h1 class="font-bold mb-0">{{ standardCartDetails?.totalPriceWithTax?.value | currency }}</h1>
            </span>
          }
                </section>
                <!-- Buttons bottom-sm block-lg -->
        <section class="col-md-12 d-flex justify-content-between mb-4 gap-1">
          <button class="c-button c-button--secondary w-100" (click)="navigateToCart()">
            {{ 'addToCartItems.editCart' | cxTranslate }}
          </button>
                    <button class="c-button c-button--primary w-100" (click)="checkPOnumber()" [disabled]="
              ((orderNo == undefined || orderNo == '') && !genMedFlag) ||
              disablePlaceOrderBtn
            ">
            {{ 'addToCartItems.continue' | cxTranslate }}
          </button>
                </section>
                <!-- Terms and condition -->
                <section class="col-md-12 mb-4 u-border-bottom-grey pb-4">
                    <div *ngIf="stdCartType; else fluCartTerm">
            <app-terms-conditions compName="TandC-checkout"></app-terms-conditions>
                    </div>
                    <ng-template #fluCartTerm>
            <app-terms-conditions compName="TandC-fluseasonviewpayment"></app-terms-conditions>
                    </ng-template>
                </section>
                <!-- modal for continue  -->
                <ng-template #continueCheckout class="checkout-popover">
                    <section class="checkout-modal">
                        <div class="modal-dialog">
                            <div class="modal-content overlay">
                                <div class="close" (click)="modalService.dismissAll()">
                  <i class="fa-solid fa-x c-icon-primary c-icon-primary-sm c-icon-round-hover mr-3 mt-4"></i>
                                </div>
                                <div class="modal-header overlay-heading">
                  <h2 class="c-heading-36 font-bold u-border-bottom-grey pb-4 w-100" *ngIf="stdCartType; else fluOrderHeader">
                                        {{ 'addToCartItems.readyToPlaceOrder' | cxTranslate }}
                                    </h2>
                                    <ng-template #fluOrderHeader>
                    <h2 class="c-heading-36 font-bold u-border-bottom-grey pb-4">{{ 'orderConfirmation.readyToReserve' | cxTranslate }}</h2>
                                    </ng-template>
                                </div>
                <div class="brand-banner py-4 px-2 mx-4 font-bold mb-4" *ngIf="orderMessage">{{ orderMessage }}</div>
                                <div class="modal-body confirm-order">
                                    <!-- Total  -->
                                    <div class="d-flex flex-column w-100 mb-4">
                                        <div class="d-flex w-100 align-items-center justify-content-between mb-2">
                      <h3 class="font-bold mb-0">{{ (stdCartType ? 'addToCartItems.orderTotal' : 'addToCartItems.estTotal') | cxTranslate }}:</h3>
                                            <h3 class="font-bold mb-0">{{ standardCartDetails?.totalPriceWithTax?.value | currency }}</h3>
                                        </div>
                    @if (standardCartDetails?.promptPayDiscountTotal) {
                      <div class="d-flex w-100 align-items-center justify-content-between">
                        <span>{{ 'addToCartItems.promptPayDiscountTotal' | cxTranslate }}:</span>
                        <span>{{ (standardCartDetails?.totalPriceWithTax?.value - standardCartDetails?.promptPayDiscountTotal) | currency }}</span>
                      </div>
                    }
                                    </div>
                  <section class="mt-4 pt-4 u-border-top-grey pb-4">
                    <h3 class="font-bold mb-3">{{ 'addToCartItems.paymentMethod' | cxTranslate }}</h3>

                    @if (selectedPaymentMethod().PaymentMethod === PaymentsMods.ECHECK) {
                      <sanofi-payment-method [paymentInfo]="selectedPaymentMethod()"/>
                      <p class="mt-2 mb-0"><span class="text-danger font-bold">{{ 'addToCartItems.eCheckDisclaimerNote' | cxTranslate }}</span>{{ 'addToCartItems.eCheckDisclaimer' | cxTranslate }}</p>
                    } @else {
                      <span>{{ 'addToCartItems.billMeLater' | cxTranslate }}</span>
                    }
                  </section>
                                    <!-- Ship -->
                  <div class="ship-location pt-4 u-border-top-grey pb-4 u-border-bottom-grey mb-4">
                    <h3 class="font-bold">{{ 'addToCartItems.shipToLocation' | cxTranslate }}</h3>
                                        <p class="mb-2">
                                            {{ selectedData?.companyName }}<br /> {{ '(' + selectedData?.unitID + ')' }}
                                        </p>
                                        <p class="mb-2" *ngIf="!stdCartType">
                      {{ selectedData?.line1 ? selectedData?.line1 : '' }} ,
                      {{ selectedData?.line2 ? selectedData?.line2 : '' }}
                      {{ selectedData?.town ? selectedData?.town : '' }} ,
                      {{ selectedData?.region?.isocodeShort ? selectedData?.region?.isocodeShort + ',' : '' }}
                      {{ selectedData?.postalCode ? selectedData?.postalCode : '' }}
                                        </p>
                                    </div>
                                    <div class="row">
                    <div class="col-md-6" *ngIf="stdCartType; else fluReservationContact">
                      <h3 class="font-bold">{{ 'addToCartItems.orderContact' | cxTranslate }}</h3>
                                            <p class="popupname">{{ orderContact?.name }}</p>
                                        </div>
                                        <ng-template #fluReservationContact>
                                            <div class="col-md-6">
                        <h3 class="font-bold">{{ 'orderConfirmation.reservationContact' | cxTranslate }}</h3>
                                                <p class="con-name">{{ orderContact?.name }}</p>
                        <p class="con-name">{{ orderContact?.fax ? orderContact?.fax : '' }}</p>
                        <a class="email-Value email-outline" *ngIf="orderContact?.email" href="{{ 'mailto:' + orderContact?.email }}">
                          {{ orderContact?.email }}
                        </a>
                      </div>
                    </ng-template>
                    <div class="col-md-6" *ngIf="stdCartType; else fluReservationContact">
                      <h3 class="font-bold">{{ 'addToCartItems.soldTo' | cxTranslate }}</h3>
                      <p id="popup-stdSoldToDetails">
                        {{ standardCartDetails?.soldtoAddress?.unitID }} <br />
                        {{ standardCartDetails?.soldtoAddress?.companyName }}
                        {{
                          standardCartDetails?.soldtoAddress?.line1 +
                            ', ' +
                            standardCartDetails?.soldtoAddress?.town +
                            ', ' +
                            standardCartDetails?.soldtoAddress?.postalCode
                        }}
                      </p>
                    </div>
                  </div>
                  <!-- Buttons -->

                  <div class="row u-border-top-grey pt-3">
                    <cx-form-errors
                      class="font-bold c-heading c-heading-h4 mb-4"
                      *ngIf="displayPoErrorMessage"
                    >
                      {{'addToCartItems.poErrorMessage'  | cxTranslate}}
                    </cx-form-errors>
                    <table class="w-100">
                      <tr>
                        <span class="spacing">
                          <button
                            type="button"
                            class="c-button c-button--secondary w-100 mx-2"
                            data-toggle="modal"
                            data-target="#overlay"
                            data-di-id="di-id-35119eec-5a7dc742"
                            (click)="editOrder()"
                            *ngIf="stdCartType; else fluEditButton"
                          >
                            {{ 'addToCartItems.editOrder' | cxTranslate }}
                          </button>
                          <ng-template #fluEditButton>
                            <button
                              type="button"
                              class="c-button c-button--secondary w-100 mx-2"
                              data-toggle="modal"
                              data-target="#overlay"
                              data-di-id="di-id-35119eec-5a7dc742"
                              (click)="editOrder()"
                            >
                            {{'orderConfirmation.editReservation' | cxTranslate }}
                            </button>
                          </ng-template>
                          <button
                            type="submit"
                            class="c-button c-button--primary w-100 mx-2"
                            data-toggle="modal"
                            data-target="#loading-order"
                            id="orderConfirmbtn"
                            data-di-id="#orderConfirmbtn"
                            (click)="placeOrder()"
                            [disabled]="disablePlaceOrderBtn"
                            [ngClass]="disablePlaceOrderBtn ? 'disableCTA' : ''"
                            *ngIf="stdCartType; else fluButton"
                          >
                            <i
                              class="fa fa-spinner fa-spin"
                              *ngIf="disablePlaceOrderBtn"
                            ></i>
                            {{ 'addToCartItems.placeOrder' | cxTranslate }}
                          </button>
                          <ng-template #fluButton>
                            <button
                              type="submit"
                              class="c-button c-button--primary w-100 mx-2"
                              data-toggle="modal"
                              data-target="#loading-order"
                              id="orderConfirmbtn"
                              data-di-id="#orderConfirmbtn"
                              (click)="placeOrder()"
                              [disabled]="disablePlaceOrderBtn"
                            >
                              {{ 'orderConfirmation.yesReserve' | cxTranslate }}
                            </button>
                          </ng-template>
                        </span>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </ng-template>
      </section>
      <!-- Payment method -->
      <section class="row u-border-bottom-grey pb-4">
        <section class="col-md-12">
          <h3 class="font-bold mb-4">{{ 'addToCartItems.paymentMethod' | cxTranslate }}</h3>
        </section>
        <section class="col-12 ">
          <app-payments-dropdown
            [allPaymentsMethods]="allPaymentsMethods"
            [(selectedPaymentMethod)]="selectedPaymentMethod"
            [eligiblePaymentMethods]="splitOrder() ? [PaymentsMods.BILL_ME_LATER] :paymentModes"
            [splitOrder]="splitOrder()"
            [payNowDisabled]="payNowDisabled()"
            (openAddCardIframe)="openModal()"
            (openAddEcIframe)="openAch()"
            [mix]="'paymentMethodsDropdown__checkoutPage'"
          />

        </section>
        <section class="container creditCard-Container" *ngIf="hidePaymentMethod === false">
          <section class="row">
            <section class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1">
              <img src="img/VISA.svg"src="img/" class="creditCard-Img" alt="visa"/>
            </section>
            <section class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1">
              <img src="img/MC.svg" class="creditCard-Img" alt="mc" />
            </section>
          </section>
        </section>

        <section class="col-md-12 col-lg-12 col-xl-12 multiple-Shipments-Msg-Div mt-4">
          <span class="text-fixed-legal-copy">
            {{ ['addToCartItems.paymentNote', 'addToCartItems.paymentNoteDefault'] | cxTranslate: { context: selectedPaymentMethod()?.PaymentMethod?.toLowerCase() } }}
          </span>
        </section>
      </section>

      <section class="row pt-4">
        <!-- Flu Contact -->
        <div *ngIf="!stdCartType">
          <h6 [ngbPopover]="popContent" [autoClose]="false" #myPopover="ngbPopover" placement="top"></h6>
          <ng-template #popContent>
            <span>{{ 'orderConfirmation.resCheckMsg' | cxTranslate }}</span>
            <div class="text-center">
              <a class="dismissStyle" (click)="myPopover.close()">{{'orderConfirmation.dismiss' | cxTranslate }}</a>
                                            </div>
                                        </ng-template>
                                    </div>
                                    <!-- Standard Contact -->
                                    <section class="col-md-12 col-lg-12 col-xl-12">
                                        <section *ngIf="stdCartType; else fluCartContact" class="row mb-4">
                                            <section class="col-8">
              <h3 class="font-bold">{{ 'addToCartItems.orderContact' | cxTranslate }}</h3>
                                            </section>
                                            <section class="col-4 text-right">
                                                <a class="c-link mt-2" *ngIf="editNotClicked">
                <span class="edit-Click" (click)="editContact()" *ngIf="editNotClicked">
                  {{ 'addToCartItems.edit' | cxTranslate }}
                </span>
                                                    <fa-icon [icon]="faPenToSquare" class="icon"></fa-icon>
                                                </a>
                                            </section>
                                        </section>
                                        <div class="row">
                                            <ng-template #fluCartContact>
                                                <div class="col-md-12 mb-4">
                <h3 class="font-bold">{{ 'addToCartItems.reservationContact' | cxTranslate }}</h3>
                                                </div>
                                            </ng-template>
                                            <div class="col-md-12" *ngIf="!stdCartType">
              <p class="mb-4">{{ 'selectVaccines.contactMsg' | cxTranslate }}</p>
                                            </div>
                                        </div>
                                    </section>
                    </section>
                    <!-- Contact form -->
                    <section class="row" *ngIf="!editNotClicked" [formGroup]="editStdForm">
                        <section class="col-md-12 c-text-input mb-3">
                            <label class="edit-label">{{
            'addToCartItems.name' | cxTranslate
          }}</label>
                            <input class="form-control edit-Form-Styling" type="text" onkeypress="return /[a-zA-Z0-9-' ]+('[a-zA-Z0-9-])?[-a-zA-Z0-9]*$/i.test(event.key)" formControlName="firstName" [ngClass]="{
              invalidClass:
                editStdForm.get('firstName').invalid &&
                (editStdForm.get('firstName').touched ||
                  editStdForm.get('firstName').dirty)
            }"
          />
          <cx-form-errors *ngIf="!editStdForm.get('firstName').value"><p>
            {{ 'addToCartItems.fieldReq' | cxTranslate }}</p>
          </cx-form-errors>
          <cx-form-errors
            *ngIf="
              editStdForm.get('firstName').dirty &&
              editStdForm.get('firstName').invalid &&
              editStdForm.get('firstName').value
            ">
                                <p>
                                    {{ 'addToCartItems.invalidName' | cxTranslate }}
                                </p>
                            </cx-form-errors>
                        </section>
                        <section class="col-md-12 c-text-input mb-3">
                            <label class="edit-label">{{'addToCartItems.phone' | cxTranslate }}</label>
                            <input class="form-control edit-Form-Styling" onkeypress="return /[0-9-]/i.test(event.key)" maxlength="12" type="text" appPhoneMask placeholder="xxx-xxx-xxxx" formControlName="phone" [ngClass]="{
              invalidClass:
                editStdForm.get('phone').invalid &&
                (editStdForm.get('phone').touched ||
                  editStdForm.get('phone').dirty)
            }" />
                            <cx-form-errors *ngIf="
              editStdForm.get('phone').dirty &&
              editStdForm.get('phone').invalid &&
              editStdForm.get('phone').value
            "
            >
            <p>{{ 'addToCartItems.invalidPhoneno' | cxTranslate }}</p>
          </cx-form-errors>
          <cx-form-errors *ngIf="!editStdForm.get('phone').value">
            <p>{{ 'addToCartItems.fieldReq' | cxTranslate }}</p>
          </cx-form-errors>
                        </section>
                        <section class="col-md-12 c-text-input mb-3">
                            <label class="edit-label">{{'addToCartItems.mobile' | cxTranslate }}</label>
                            <input class="form-control edit-Form-Styling" onkeypress="return /[0-9-]/i.test(event.key)" maxlength="12" placeholder="xxx-xxx-xxxx" appPhoneMask type="text" formControlName="mobile" [ngClass]="{
              invalidClass:
                editStdForm.get('mobile').invalid &&
                (editStdForm.get('mobile').touched ||
                  editStdForm.get('mobile').dirty)
            }" />
                            <cx-form-errors class="txt-error" *ngIf="
              editStdForm.get('mobile').dirty &&
              editStdForm.get('mobile').invalid
            "
            >
            <p>{{ 'addToCartItems.invalidPhoneno' | cxTranslate }}</p>
          </cx-form-errors>
                        </section>
                        <section class="col-md-12 c-text-input mb-3">
                            <label class="edit-label">{{'addToCartItems.email' | cxTranslate }}</label>
                            <ng-select class="w-100 email-Styling" [items]="emailsArray" bindLabel="emailId" bindValue="emailId" [multiple]="false" formControlName="emailId" [clearable]="false" [(ngModel)]="chosenEmail">
                            </ng-select>
                        </section>
                        <section class="col-md-12 c-text-input mb-3" *ngIf="chosenEmail === 'Add Other E-mail Address'">
                            <input class="form-control edit-Form-Styling" type="email" formControlName="newemailId" maxlength="241" [ngClass]="{
              invalidClass:
                editStdForm.get('newemailId').invalid &&
                (editStdForm.get('newemailId').touched ||
                  editStdForm.get('newemailId').dirty)
            }" />
                            <span class="trash-div">
            <i class="fas fa-trash-alt c-icon-primary c-icon-primary-sm" (click)="delEmail()"></i>
          </span>
                            <cx-form-errors class="txt-error" *ngIf="
              editStdForm.get('newemailId').invalid &&
              (editStdForm.get('newemailId').dirty ||
                editStdForm.get('newemailId').touched) &&
              editStdForm.get('newemailId').value !== 0
            ">
                                <p>You have entered an invalid email address</p>
                            </cx-form-errors>
                        </section>
                        <section class="col-md-12 d-flex mt-2 mb0" *ngIf="failedContactUpdate">
                            <cx-form-errors class="txt-error c-text-input">
                                <p>{{'addToCartItems.saveFailed' | cxTranslate}}</p>
                            </cx-form-errors>
                        </section>
                        <!-- buttons -->
        <section class="col-md-12 d-flex mt-4 justify-content-around justify-content-lg-end">
          <button (click)="onCancelClick()" class="c-button c-button--secondary mr-lg-2 ml-lg-2">
            {{ 'addToCartItems.cancel' | cxTranslate }}
          </button>
          <button (click)="updateOrderContact()" class="c-button c-button--primary mr-lg-2 ml-lg-2">
            {{ 'addToCartItems.save' | cxTranslate }}
          </button>
                        </section>
                    </section>
                    <!-- Contact details -->
                    <section class="row contact-Main-Row" *ngIf="editNotClicked">
                        <section class="col-md-3 mb-2">
          <span class="font-bold">{{'addToCartItems.name' | cxTranslate }}</span>
                        </section>
                        <section class="col-md-9">
                            <span>{{ orderContact?.name }}</span>
                        </section>
                        <section class="col-md-3 mb-2" *ngIf="stdCartType">
          <span class="font-bold">{{'addToCartItems.phone' | cxTranslate }}</span>
                        </section>
                        <section class="col-md-9" *ngIf="stdCartType">
                            <span>{{ orderContact?.phoneNo ? orderContact?.phoneNo : '' }}</span>
                        </section>
        <section class="col-md-3 mb-2" *ngIf="!stdCartType && orderContact?.fax">
          <span class="font-bold">{{'selectVaccines.fax' | cxTranslate }}</span>
                        </section>
                        <section class="col-md-9" *ngIf="!stdCartType && orderContact?.fax">
                            <span>{{ orderContact?.fax }}</span>
                        </section>
                        <section class="col-md-3 mb-2" *ngIf="orderContact?.mobileNo">
          <span class="font-bold">{{'addToCartItems.mobile' | cxTranslate }}</span>
                        </section>
                        <section class="col-md-9" *ngIf="orderContact?.mobileNo">
                            <span>{{ orderContact?.mobileNo }}</span>
                        </section>
                        <section class="col-md-3 mb-2">
          <span class="font-bold">{{'addToCartItems.email' | cxTranslate }}</span>
                        </section>
                        <section class="col-md-9" *ngIf="stdCartType">
                            <a class="c-force-wrap" href="{{ 'mailto:' + orderContact?.email }}">{{ orderContact?.email }}</a>
        </section>
        <section class="col-md-9" *ngIf="!stdCartType">
          <a class="c-force-wrap"
            href="{{
              'mailto:' +
                (orderContact?.email ? orderContact?.email : userEmail)
            }}"
            >{{ orderContact?.email ? orderContact?.email : userEmail }}</a
          >
        </section>
        <section class="col-md-3 mb-2" *ngIf="!stdCartType">
          <span class="font-bold">{{'selectVaccines.placedBy' | cxTranslate }}</span>
        </section>
        <section class="col-md-9" *ngIf="!stdCartType">
          <span>
            {{ userFname ? userFname : '' }}
            {{ userLname ? userLname : '' }}
          </span>
        </section>
      </section>

      <!-- Addresses -->
      <section class="row mt-4 text-fixed-medium">
        <section class="col-lg-6 mb-4 mb-lg-0">
          <section class="row">
            <section class="col-md-12">
              <h4 class="font-bold">{{ 'addToCartItems.billingAddress' | cxTranslate }}</h4>
            </section>
            <section class="col-md-12">
              <span>
                {{ 'addToCartItems.accountNo' | cxTranslate }}:
                {{ standardCartDetails?.billingAddress?.unitID ? standardCartDetails?.billingAddress?.unitID : '' }}
              </span>
            </section>
            <section class="col-md-12">
              <span>{{ standardCartDetails?.billingAddress?.companyName ? standardCartDetails?.billingAddress?.companyName : '' }}</span>
            </section>
            <section class="col-md-12">
              <span>
                {{ standardCartDetails?.billingAddress?.line1 ? standardCartDetails?.billingAddress?.line1 : '' }},
                {{ standardCartDetails?.billingAddress?.line2 ? standardCartDetails?.billingAddress?.line2 : '' }}
              </span>
            </section>
            <section class="col-md-12">
              <span>
                {{ standardCartDetails?.billingAddress?.town ? standardCartDetails?.billingAddress?.town : '' }},
                {{ standardCartDetails?.billingAddress?.region?.isocodeShort ? standardCartDetails?.billingAddress?.region?.isocodeShort : '' }}
                {{ standardCartDetails?.billingAddress?.postalCode ? standardCartDetails?.billingAddress?.postalCode : '' }}
              </span>
            </section>
          </section>
        </section>
        <section class="col-lg-6">
          <section class="row">
            <section class="col-md-12 col-lg-12 col-xl-12 sold-Address-Div">
              <h4 class="font-bold">{{ 'addToCartItems.soldToAddress' | cxTranslate }}</h4>
            </section>
            <section class="col-md-12 col-lg-12 col-xl-12">
              <span>
                {{ 'addToCartItems.accountNo' | cxTranslate }}:
                {{ standardCartDetails?.soldtoAddress?.unitID ? standardCartDetails?.soldtoAddress?.unitID : '' }}
              </span>
            </section>
            <section class="col-md-12 col-lg-12 col-xl-12">
              <span>{{ standardCartDetails?.soldtoAddress?.companyName ? standardCartDetails?.soldtoAddress?.companyName : '' }}</span>
            </section>
            <section class="col-md-12 col-lg-12 col-xl-12">
              <span>
                {{ standardCartDetails?.soldtoAddress?.line1 ? standardCartDetails?.soldtoAddress?.line1 : '' }},
                {{ standardCartDetails?.soldtoAddress?.line2 ? standardCartDetails?.soldtoAddress?.line2 : '' }}
              </span>
            </section>
            <section class="col-md-12 col-lg-12 col-xl-12">
              <span>
                {{ standardCartDetails?.soldtoAddress?.town ? standardCartDetails?.soldtoAddress?.town : '' }},
                {{ standardCartDetails?.soldtoAddress?.region?.isocodeShort ? standardCartDetails?.soldtoAddress?.region?.isocodeShort : '' }}
                {{ standardCartDetails?.soldtoAddress?.postalCode ? standardCartDetails?.soldtoAddress?.postalCode : '' }}
              </span>
            </section>
          </section>
        </section>
        <section class="col-md-12 mt-4">
          <a class="c-link" target="_blank" (click)="billingAccount()">
            <span class="manage-Billing-info">{{'addToCartItems.billingInfo' | cxTranslate }}</span>
          </a>
                        </section>
                    </section>
                    </div>
                    </div>
            </section>
